import React,{useState} from 'react';
// import "./header.css"
import LogoImage from "../../../assets/logo.png";
import { Nav,NavLink,NavMenu,NavBtn,NavBtnLink,Bars,Logo, OverLay,OverLayContent } from './NavbarElements';


const NavBar = ({toggle}) =>{
    return (
        <>
            <Nav>
                <NavLink to='/'>
                    {/* <img src={Logo} alt="logo" id='logo'/> */}
                    <h1 id='brand'>Svik</h1>
                    {/* <div id='brand'>
                        <Logo src={LogoImage}/>
                        <h1>Svik</h1>
                    </div> */}
                </NavLink>
                <Bars onClick={toggle}/>
                <NavMenu>
                    <NavLink to='/donate' activeStyle>
                        Donate
                    </NavLink>
                    <NavLink to='/work' activeStyle>
                        Work with Us    
                    </NavLink>
                    <NavLink to='/#about' activeStyle>
                        About
                    </NavLink>

                    {/* <NavBtnLink to='/register'>Join Now</NavBtnLink> */}
                </NavMenu>
                {/* <NavBtn>
                        <NavBtnLink to='/register'>Join Now</NavBtnLink>
                </NavBtn> */}
            </Nav>
        </>
    );
};


export default NavBar;







// class Header extends Component {
//     constructor(props) {
//         super(props);
//     }
//     state = {}
//     render() {
//         return (
//             <header className="header">
                    
//                     <Link to='/' class="logo">Svik</Link>
//                     <div className='header-links-right'>
//                         <Link to='/support_us' id='link'>Support Us</Link>
//                         <Link to='/register' id='button'></Link>
                        
//                     </div>
//                     {/* <Link to='/register'>Home</Link> */}
//             </header>
//         );
//     }
// }

// export default Header;

